<template>
	<svg
		width="20"
		height="16"
		viewBox="0 0 20 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			y="6.16214"
			width="4"
			height="13.1373"
			rx="2"
			transform="rotate(-45 0 6.16214)"
			fill="white"
		/>
		<rect
			x="16.3815"
			width="4"
			height="16.1878"
			rx="2"
			transform="rotate(36.8809 16.3815 0)"
			fill="white"
		/>
	</svg>
</template>

<script>
export default {
	name: "AcceptIcon",
};
</script>
